import { QueryOperation, SearchQuery } from "../../code/search-query/search-query";
import { DataColumn } from "../../controls/Data.default";
import { buildSearchQuery, dateRangeValue, QueryFieldMapping } from "../../code/search-query/query-mapper";
import { Dayjs } from "dayjs";

export interface BundlesForm {
  readonly name: string;
  readonly createdByUserUserName: string;
  readonly createdOn: Dayjs[];
}

export const bundlesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
  },
  {
    title: "Created by",
    key: "createdByUserUserName",
    width: 192,
    sort: true,
  },
  {
    title: "Created on",
    key: "createdOn",
    width: 192,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Description",
    key: "description",
    width: 192,
    sort: true,
  },
  {
    title: "Questionnaires",
    key: "questionnairesCount",
    width: 192,
    sort: true,
    type: "badge",
  },
  {
    title: "Languages",
    key: "availableLanguagesCount",
    width: 192,
    sort: true,
    type: "badge",
  },
  {
    title: "Assigned Companies",
    key: "assignedCompaniesCount",
    width: 192,
    sort: true,
    type: "badge",
  },
  {
    title: "Test Groups",
    key: "testGroupsCount",
    width: 192,
    sort: true,
    type: "badge",
  },
];

const bundlesQueryMappings: QueryFieldMapping[] = [
  { formField: "name", operation: QueryOperation.Contains },
  { formField: "createdByUserUserName", operation: QueryOperation.Contains },
  { formField: "createdOn", operation: QueryOperation.Between, transform: dateRangeValue },
];

export const mapBundlesViewQuery = (values: BundlesForm): SearchQuery =>
  buildSearchQuery(values, bundlesQueryMappings);
